import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import { BsWhatsapp } from "react-icons/bs";
import { Mail, MapPin, Clock, MessageSquare, ArrowRight } from "lucide-react";

function Contact() {
  const whatsappNumber = "5547992229810";

  return (
    <section id="contact" className="contact-section-elite py-20 position-relative">
      <Container className="position-relative z-index-2">
        <div className="text-center mb-10" data-aos="fade-up">
           <h6 className="text-gold text-uppercase fw-bold mb-3 ls-3">Ready for Elite</h6>
           <h2 className="section-title-premium text-white">Inicie seu <span className="highlight-gold">Projeto</span></h2>
           <p className="section-subtitle-premium mx-auto max-w-700 text-gray-sub">
             Nossa engenharia está pronta para transformar seus desafios em ecossistemas de alta performance. 
             Experimente o padrão Henrimack.
           </p>
        </div>

        <Row className="gy-4 align-items-stretch">
          {/* Informações de Contato */}
          <Col lg={5} data-aos="fade-right">
            <div className="contact-info-card-elite h-100 p-5">
               <h4 className="fw-900 mb-5 text-white">Canais de Resposta</h4>
               
               <div className="d-flex align-items-start mb-5">
                  <div className="icon-box-gold-mini me-4">
                    <MessageSquare size={20} />
                  </div>
                  <div>
                    <h6 className="fw-bold mb-1 text-white">WhatsApp direto</h6>
                    <p className="text-gray-sub mb-0">+55 47 99222-9810</p>
                  </div>
               </div>

               <div className="d-flex align-items-start mb-5">
                  <div className="icon-box-gold-mini me-4">
                    <Mail size={20} />
                  </div>
                  <div>
                    <h6 className="fw-bold mb-1 text-white">E-mail corporativo</h6>
                    <a href="mailto:contato@henrimacksistemas.com.br" className="small text-gray-sub">contato@henrimacksistemas.com.br</a>
                  </div>
               </div>

               <div className="d-flex align-items-start mb-5">
                  <div className="icon-box-gold-mini me-4">
                    <MapPin size={20} />
                  </div>
                  <div>
                    <h6 className="fw-bold mb-1 text-white">Sede Técnica</h6>
                    <p className="text-gray-sub mb-0">Santa Catarina - Atendimento Global</p>
                  </div>
               </div>

               <div className="d-flex align-items-start">
                  <div className="icon-box-gold-mini me-4">
                    <Clock size={20} />
                  </div>
                  <div>
                    <h6 className="fw-bold mb-1 text-white">Horário de Operação</h6>
                    <p className="text-gray-sub mb-0">Segunda à Sexta, 08h às 18h</p>
                  </div>
               </div>
            </div>
          </Col>

          {/* CTA Principal */}
          <Col lg={7} data-aos="fade-left">
            <div className="contact-cta-card-elite h-100 p-5 d-flex flex-column justify-content-center text-center">
               <div className="cta-icon-glow mb-4">
                  <BsWhatsapp size={40} className="text-gold" />
               </div>
               <h3 className="fw-900 mb-4 text-white">Atendimento em Tempo Real</h3>
               <p className="text-gray-sub mb-10 max-w-500 mx-auto">
                 Fale diretamente com nosso arquiteto de soluções e inicie sua jornada 
                 para o próximo nível tecnológico.
               </p>
               
               <a
                  href={`https://wa.me/${whatsappNumber}?text=Olá!%20Gostaria%20de%20solicitar%20um%20projeto%20de%20elite%20com%20a%20Henrimack.`}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="btn-whatsapp-elite mx-auto"
                >
                  Iniciar Sessão no WhatsApp <ArrowRight size={18} className="ms-2" />
                </a>

                <div className="mt-10 p-4 rounded-4 bg-glass-quote">
                   <p className="small mb-0 text-gray-sub italic">
                      "Exclusividade técnica e segurança de dados são os nossos pilares inegociáveis."
                   </p>
                </div>
            </div>
          </Col>
        </Row>
      </Container>

      {/* Botão flutuante fixo */}
      <a
        href={`https://wa.me/${whatsappNumber}`}
        className="floating-whatsapp-elite"
        target="_blank"
        rel="noopener noreferrer"
        aria-label="WhatsApp"
      >
        <BsWhatsapp size={28} />
      </a>

      <style>{`
        .contact-section-elite { background: transparent; padding: 8rem 0 4rem; overflow: hidden; }
        .ls-3 { letter-spacing: 3px; font-size: 0.75rem; }
        .text-gray-sub { color: #888; }
        .max-w-700 { max-width: 700px; }
        .max-w-500 { max-width: 500px; }
        .fw-900 { font-weight: 900; }

        .contact-info-card-elite {
           background: rgba(255,255,255,0.02);
           border: 1px solid rgba(255,255,255,0.05);
           border-radius: 40px;
           box-shadow: 0 40px 100px rgba(0,0,0,0.5);
           position: relative;
        }

        .icon-box-gold-mini {
           background: rgba(228,168,122,0.1);
           color: var(--elite-gold);
           width: 45px; height: 45px;
           display: flex; align-items: center; justify-content: center;
           border-radius: 12px;
           flex-shrink: 0;
        }

        .contact-cta-card-elite {
           background: rgba(255,255,255,0.01);
           border: 1px dashed rgba(228,168,122,0.15);
           border-radius: 40px;
           position: relative;
           overflow: hidden;
        }

        .cta-icon-glow {
           display: inline-block; padding: 1.5rem;
           background: radial-gradient(circle, rgba(228,168,122,0.1), transparent 70%);
        }

        .bg-glass-quote {
           background: rgba(255,255,255,0.03);
           border: 1px solid rgba(255,255,255,0.02);
        }

        .btn-whatsapp-elite {
          background-color: var(--elite-gold);
          color: #000;
          font-weight: 800;
          padding: 1.2rem 3rem;
          border-radius: 15px;
          text-decoration: none;
          display: inline-flex;
          align-items: center;
          transition: all 0.4s ease;
          text-transform: uppercase;
          letter-spacing: 1px;
          box-shadow: 0 15px 40px rgba(228, 211, 102, 0.2);
        }

        .btn-whatsapp-elite:hover {
          background-color: #fff;
          transform: translateY(-5px);
          box-shadow: 0 20px 50px rgba(228, 168, 122, 0.4);
          color: #000;
        }

        .floating-whatsapp-elite {
          position: fixed;
          bottom: 30px;
          right: 30px;
          background-color: var(--elite-gold);
          color: #000;
          width: 60px; height: 60px;
          display: flex; align-items: center; justify-content: center;
          border-radius: 50%;
          box-shadow: 0 15px 30px rgba(228,168,122,0.3);
          transition: all 0.3s cubic-bezier(0.175, 0.885, 0.32, 1.275);
          z-index: 1000;
          text-decoration: none;
        }

        .floating-whatsapp-elite:hover {
          transform: scale(1.15) rotate(10deg);
          background-color: #fff;
          color: #000;
        }

        @media (max-width: 768px) {
           .contact-section-elite { padding: 5rem 0; }
           .contact-info-card-elite, .contact-cta-card-elite { padding: 3rem 1.5rem !important; }
        }
      `}</style>
    </section>
  );
}

export default Contact;
